import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import ROUTE_NAMES from "@/core/route/util/routeNames"
import { ConnectSlackTooltipFragment$key } from "@/organization/slack/__generated__/ConnectSlackTooltipFragment.graphql"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoButton, DiscoText, DiscoTooltip } from "@disco-ui"
import { graphql, useFragment } from "react-relay"
import { useHistory } from "react-router-dom"

interface Props {
  organizationKey: ConnectSlackTooltipFragment$key
  children: React.ReactElement
}

function ConnectSlackTooltip({ organizationKey, children }: Props) {
  const classes = useStyles()
  const history = useHistory()
  const activeOrganization = useActiveOrganization()!

  const organization = useFragment(
    graphql`
      fragment ConnectSlackTooltipFragment on Organization {
        viewerMembership {
          organizationMembershipSlackConnection {
            id
          }
        }
      }
    `,
    organizationKey
  )

  return (
    <DiscoTooltip
      content={
        <div className={classes.contentContainer}>
          <DiscoText>
            {"Slack connection is required to view available channels."}
          </DiscoText>

          {activeOrganization.viewerIsOwnerOrAdmin && (
            <DiscoButton
              variant={"outlined"}
              color={"grey"}
              onClick={() =>
                history.push(ROUTE_NAMES.ADMIN.INTEGRATIONS.SETUP_ADMIN_SLACK.ROOT, {
                  hideStepper: true,
                  successRedirectPathname: `${location.pathname}${location.search}`,
                })
              }
            >
              {"Connect Slack"}
            </DiscoButton>
          )}
        </div>
      }
      placement={"right"}
      interactive
      disabled={Boolean(
        organization.viewerMembership?.organizationMembershipSlackConnection?.id
      )}
    >
      <span>{children}</span>
    </DiscoTooltip>
  )
}

const useStyles = makeUseStyles((theme) => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
}))

export default ConnectSlackTooltip
